import axios from 'axios'
import router from '../router'
let api_root=""
console.log('api_root',process.env.NODE_ENV)
if (process.env.NODE_ENV == 'development') {
  // 开发环境
  api_root = "";
  window.$mapApi='map/'
  window.$weatherApi="weather/"
} else if(process.env.NODE_ENV === 'test') {
  // 生产环境
  api_root = "http://qufenscreen-api.microrefit.com/";
  window.$mapApi='https://apis.map.qq.com/'
  window.$weatherApi="weather/"
}else{
  api_root = "https://screen-api.shubote.cn/";
}


axios.interceptors.request.use(config => {
    // console.log(process.env.NODE_ENV, "请求模式")
    // if (process.env.NODE_ENV == 'development') {
    //     //测试的业务
    //     config.baseURL = ''
    // } else {
    //     //正式的业务
    //     config.baseURL = ''
    // }
    config.baseURL=api_root
    return config 
}, error => {
    console.log("err", error)
    return Promise.reject(error)
})

// 响应拦截
axios.interceptors.response.use(response => {
    return response

}, error => {

    return Promise.reject(error)
})

export default axios